/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetWorkUnitsTrendSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetWorkUnitsTrendRequest = {
  /**
   * Start of the window (ISO 8601). Defaults to 30 days before `to`.
   */
  from?: Date | undefined;
  /**
   * End of the window (ISO 8601). Defaults to now.
   */
  to?: Date | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetWorkUnitsTrendSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetWorkUnitsTrendSecurity$outboundSchema: z.ZodMiniType<
  GetWorkUnitsTrendSecurity$Outbound,
  GetWorkUnitsTrendSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getWorkUnitsTrendSecurityToJSON(
  getWorkUnitsTrendSecurity: GetWorkUnitsTrendSecurity,
): string {
  return JSON.stringify(
    GetWorkUnitsTrendSecurity$outboundSchema.parse(getWorkUnitsTrendSecurity),
  );
}

/** @internal */
export type GetWorkUnitsTrendRequest$Outbound = {
  from?: string | undefined;
  to?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetWorkUnitsTrendRequest$outboundSchema: z.ZodMiniType<
  GetWorkUnitsTrendRequest$Outbound,
  GetWorkUnitsTrendRequest
> = z.pipe(
  z.object({
    from: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    to: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getWorkUnitsTrendRequestToJSON(
  getWorkUnitsTrendRequest: GetWorkUnitsTrendRequest,
): string {
  return JSON.stringify(
    GetWorkUnitsTrendRequest$outboundSchema.parse(getWorkUnitsTrendRequest),
  );
}
